<i18n src="../../locales/lang.json"></i18n>

<template>
  <div>
    <modal-empty showheader="false" ref="thisModal" size="modal-lg p-0">
      <div class="container-fluid">
        <div class="row form-group p-3" style="background-color: #81DB00 !important;">
          <div class="col-12">
            <ul class="setup-panel row text-center" style="list-style-type:none;" v-bind:id="'wizard' + getId()">
              <li class="col-4 nux-link" v-bind:class="getActiveClass(0)">
                <a href="#step-1" @click="gotoStep(0)">
                  <p><span class="btn bg-transparent rounded-pill border-2 btn-icon nux-flow-number">1</span></p>
                  <p class="nux-mobile-lesser">{{ $t('NUX_intro_title_collaborate') }}</p>
                </a>
              </li>
              <li class="col-4 nux-link" v-bind:class="getActiveClass(1)">
                <a href="#step-2" @click="gotoStep(1)">
                  <p><span class="btn bg-transparent rounded-pill border-2 btn-icon nux-flow-number">2</span></p>
                  <p class="nux-mobile-lesser">{{ $t('NUX_intro_title_dynamic_task') }}</p>
                </a>
              </li>
              <li class="col-4 nux-link" v-bind:class="getActiveClass(2)">
                <a href="#step-3" @click="gotoStep(2)">
                  <p><span class="btn bg-transparent rounded-pill border-2 btn-icon nux-flow-number">3</span></p>
                  <p class="nux-mobile-lesser">{{ $t('NUX_intro_title_rich_filtering') }}</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="row setup-content animated fadeIn fast" v-show="currentStep == 0">
          <div class="col-md-6 py-md-3">
            <img class="mx-auto d-block" src="/Images/nux-collaborate.png" width="75%" />
          </div>
          <div class="col-md-6 pl-md-5 pt-md-3">
            <span class="custom-medium-text">
              {{ $t('NUX_intro_content_collaborate') }}
            </span>
          </div>
        </div>
        <div class="row setup-content  animated fadeIn fast" v-show="currentStep == 1">
          <div class="col-md-6 py-md-3">
            <img class="mx-auto d-block" src="/Images/nux-task-management.png" width="75%" width="75%" />
          </div>

          <div class="col-md-6 pl-md-5 pt-md-3">
            <span class="custom-medium-text">
              {{ $t('NUX_intro_content_dynamic_task') }}

            </span>
          </div>
        </div>
        <div class="row setup-content animated fadeIn fast" v-show="currentStep == 2">
          <div class="col-md-6 py-md-5">
            <img class="mx-auto d-block" src="/Images/nux-filter.png" width="75%" />
          </div>

          <div class="col-md-6 pb-2 pb-md-3 px-5 px-md-5 pt-md-5">
            <span class="custom-medium-text">
              {{ $t('NUX_intro_content_rich_filtering') }}
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 p-3">
            <button v-if="finalStep == true" id="activate-step-2" class="btn skin btn-primary pull-right mr-1" @click="close">{{ $t('get_started') }}</button>
            <button v-if="finalStep == false" id="activate-step-2" class="btn skin btn-primary pull-right mr-1" @click="stepNext">{{ $t('next') }}</button>
            <button v-if="currentStep > 0" id="activate-step-2" class="btn pull-right mr-1" @click="stepPrevious">{{ $t('previous') }}</button>
          </div>
        </div>
      </div>
    </modal-empty>
    <ticker ref="ticker"></ticker>
  </div>
</template>

<script>

  import ModalEmpty from "../modals/modal-empty.vue";
  import ticker from '../common/common-ticker.vue'

  var steps = [];
  var currentStep = 0;
  var finalStep = false;

  export default {
    name: "nux-flow",
    components: {
      ModalEmpty,
      ticker
    },
    props: {
      
      state: {
        type: String,
        default: "closed"
      },
      startlink: {
        type: String,
        default: null
      },
      
    },
    data() {
      return {
        steps,
        currentStep,
        finalStep
      };
    },
    methods: {
      getId() {
        return this._uid;
      },
      open() {
        this.$refs.thisModal.open();
      },
      close() {
        if (this.startlink != null) {
          this.$refs.ticker.start("nuxForm");
          location.href = this.startlink;
        }
        else
          this.$refs.thisModal.close();
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      
      openWithUrl(url) {
        this.startlink = url;
        this.open();
      },
      stepNext() {
        
        this.currentStep = this.currentStep + 1;
        if (this.currentStep + 1 == this.steps.length)
          this.finalStep = true;
        else
          this.finalStep = false;
      },
      stepPrevious() {
        this.currentStep = this.currentStep - 1;
        this.finalStep = false;
      },
      checkSteps() {
        this.steps = $('#wizard' + this.getId() + ' li a');
      },
      gotoStep(step) {
        this.currentStep = step;
        if (this.currentStep + 1 == this.steps.length)
          this.finalStep = true;
        else
          this.finalStep = false;
      },
      getActiveClass(item) {
        if(this.currentStep == item)
        return "active";
        return "disabled";
      }
    

    },
    computed: {
      
    },
    watch: {
      
    },
    mounted() {
      if (this.state == "open") {
        this.open();
      }
      this.$root.$on('display_nux_intro', this.openWithUrl);

      $(document).ready(this.checkSteps);

      $(document).ready(function () {
        

      });

    },
    created() {
      
    },
  };

</script>

<style>

  .nux-flow-number{
      line-height:12px;
      margin-bottom:4px;
      margin-right:5px;

  }


  .nux-link {
    outline: none;
  }

  .nux-link p, .nux-link p .nux-flow-number {
    color: #528900 !important;
  }

  .nux-link p .nux-flow-number {
      border-color:#528900 !important;
  }


  .nux-link.active p, .nux-link.active p .nux-flow-number {
    color: white !important;
  }

    .nux-link.active p .nux-flow-number {
      border-color: white !important;
    }


  @media (max-width: 768px) {
    .nux-mobile-lesser{
        font-size:12px;
    }
  }

 
</style>



// WEBPACK FOOTER //
// src/components/nux/nux-flow2.vue